import quickstart from 'p1ng-quickstart';
import Vue from 'vue';

Vue.use(quickstart);
